import { EDITOR_NOTE_ID, UserAvatar, UserAvatarSizes, useI18N } from '@vivino/js-web-common';
import PropTypes from 'prop-types';
import React from 'react';

import ReadMoreText, { READ_MORE_COLORS } from 'vivino-js/components/ReadMoreText';

import styles from './fullEditorNote.scss';

const TRANSLATIONS = {
  wineDescription: 'components.deal_wine_page.editor_note.wine_description',
};

const FullEditorNotePresentational = ({ offerTitle, editorNote, countryManager }) => {
  const { t } = useI18N();
  if (!offerTitle || !editorNote) {
    return null;
  }

  return (
    <div className={styles.editorsNote} id={EDITOR_NOTE_ID}>
      <div>
        <div className={styles.editorNoteTitle}>{t(TRANSLATIONS.wineDescription)}</div>
        <div className={styles.offerTitle}>“{offerTitle}”</div>
        <div className={styles.note}>
          <ReadMoreText
            text={editorNote}
            maxHeight={280}
            colorType={READ_MORE_COLORS.COLOR_NOTE}
            htmlInject
          />
        </div>

        {countryManager && (
          <div className={styles.editor}>
            <div className={styles.imageContainer}>
              <UserAvatar user={countryManager.user} size={UserAvatarSizes.Large} />
            </div>
            <div className={styles.info}>
              <div className={styles.comment}>{countryManager.short_description}</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

FullEditorNotePresentational.propTypes = {
  offerTitle: PropTypes.string,
  editorNote: PropTypes.string,
  countryManager: PropTypes.object,
};

export default FullEditorNotePresentational;
